<template>
  <div class="area-choice">
    <label class="label">{{ labelText }}</label>

    <div class="select-wrapper">
      <select @change="onChange" :value="selectedArea?.id || ''">
        <option disabled value="">
          {{ placeholderText }}
        </option>

        <option v-for="area in areas" :key="area.id" :value="area.id">
          {{ area.name }}
        </option>
      </select>

      <span class="arrow"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AreaChoice',

  props: {
    areas: {
      type: Array,
      required: true
    },
    selectedArea: {
      type: Object,
      default: null
    },
    labelText: {
      type: String,
      default: '현장 선택'
    },
    placeholderText: {
      type: String,
      default: '현장을 선택하세요'
    }
  },

  emits: ['change'],

  methods: {
    onChange(event) {
      const areaId = Number(event.target.value)
      const area = this.areas.find(a => a.id === areaId)
      this.$emit('change', area)
    }
  }
}
</script>


<style scoped>
.area-choice {
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 10px 14px;
  background: rgba(255,255,255,0.45);
  border: 1px solid rgba(0,0,0,0.04);
  border-radius: 14px;

  backdrop-filter: blur(6px);
  transition: all 0.2s ease;
}

.area-choice:hover {
  background: rgba(255,255,255,0.75);
  border-color: rgba(59,130,246,0.15);
  box-shadow: 0 4px 12px rgba(0,0,0,0.04);
}

.label {
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--color-text-main);
  white-space: nowrap;
  min-width: 52px;
  margin-bottom: 0;
}

.select-wrapper {
  position: relative;
  width: 260px;
}

select {
  width: 100%;
  height: 42px;
  padding: 0 42px 0 14px;

  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-text-main);

  background: linear-gradient(
    to bottom,
    #ffffff,
    #f8fafc
  );

  border: 1px solid #d7dde5;
  border-radius: 12px;

  appearance: none;
  cursor: pointer;

  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.12s ease;
}

select:hover {
  border-color: #c4d0df;
}

select:has(option:disabled:checked) {
  color: var(--color-text-sub);
}

select:focus {
  outline: none;
  background: #fff;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(59,130,246,0.12);
}

.arrow {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-20%);
  pointer-events: none;

  width: 0;
  height: 0;

  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #94a3b8;
}
</style>